// @ts-check
import React from 'react';
import PropTypes from 'prop-types';
import { MenuItem, Select } from '@mui/material';

/** @typedef {'allow' | 'deny'} LocationFeatureFlagAction */

/**
 * @param {{
 *   value: LocationFeatureFlagAction,
 *   featureFlag: string,
 *   disabled?: boolean,
 *   ariaLabel?: string,
 *   onChange: (action: LocationFeatureFlagAction) => void,
 * }} props
 */
const LocationFeatureFlagSelect = ({ value, featureFlag, disabled = false, ariaLabel, onChange }) => {
  return (
    <Select
      value={value}
      disabled={disabled}
      onChange={(event) => onChange(event.target.value === 'allow' ? 'allow' : 'deny')}
      inputProps={{ 'aria-label': ariaLabel ?? `${featureFlag} feature flag action` }}
      size="small"
    >
      <MenuItem value="allow">Allow</MenuItem>
      <MenuItem value="deny">Deny</MenuItem>
    </Select>
  );
};

LocationFeatureFlagSelect.propTypes = {
  value: PropTypes.oneOf(['allow', 'deny']).isRequired,
  featureFlag: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  ariaLabel: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};

export default LocationFeatureFlagSelect;
